<template>
  <div
    class="biz-gubun-picker"
    :class="{
      'biz-gubun-picker--valid': hasSelection,
      'biz-gubun-picker--invalid': showInvalid,
    }"
  >
    <p v-if="loading" class="biz-gubun-picker__status">사업구분 불러오는 중...</p>
    <p v-else-if="loadError" class="biz-gubun-picker__status biz-gubun-picker__status--error">
      {{ loadError }}
    </p>
    <template v-else>
      <div class="biz-gubun-picker__chips">
        <button
          v-for="item in visibleOptions"
          :key="item.value"
          type="button"
          class="biz-gubun-picker__chip"
          :class="{ 'biz-gubun-picker__chip--on': modelValue.includes(item.value) }"
          :disabled="disabled"
          @click="toggle(item.value)"
        >
          {{ item.label }}
        </button>
      </div>
      <p v-if="hasSelection" class="biz-gubun-picker__summary">
        {{ modelValue.length }}개 선택 · {{ modelValue.join(', ') }}
      </p>
      <p v-else class="biz-gubun-picker__hint">해당하는 서비스를 모두 선택해 주세요.</p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { BizGubunOption } from '@/api/member'
import { filterBizGubunOptions } from '@/utils/bizGubun'

const props = withDefaults(
  defineProps<{
    modelValue: string[]
    options: BizGubunOption[]
    loading?: boolean
    loadError?: string
    disabled?: boolean
    showInvalid?: boolean
  }>(),
  {
    loading: false,
    loadError: '',
    disabled: false,
    showInvalid: false,
  },
)

const emit = defineEmits<{
  'update:modelValue': [value: string[]]
}>()

const visibleOptions = computed(() => filterBizGubunOptions(props.options))

const hasSelection = computed(() => props.modelValue.length > 0)

function toggle(value: string) {
  if (props.disabled) return

  const next = props.modelValue.includes(value)
    ? props.modelValue.filter((item) => item !== value)
    : [...props.modelValue, value]

  emit('update:modelValue', next)
}
</script>

<style lang="scss" src="./BizGubunPicker.scss"></style>
